export default __webpack_public_path__ + "static/media/Savant's Robes of the Crescent.321ec8b8.jpg";